// import React from "react";
// import { Link } from "react-router-dom";

// // ✅ MUI Icons
// import FacebookIcon from "@mui/icons-material/Facebook";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import TwitterIcon from "@mui/icons-material/Twitter";

// export default function Footer() {
//   return (
//     <>
//       <style>{`
//         .footer {
//           background: rgba(255,255,255,0.85);
//           backdrop-filter: blur(10px);
//           padding: 40px 20px 15px;
//           color: #022c32;
//           font-family: "Poppins", sans-serif;
//           border-top: 1px solid rgba(0,0,0,0.1);
//           {/* margin-top: 100px; */}

//         }

//         .footer-content {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//           max-width: 1100px;
//           margin: auto;
//         }

//         .footer-col h4 {
//           font-size: 20px;
//           font-weight: 800;
//           margin-bottom: 12px;
//           color: #03b8b3;
//         }

//         .footer-col a {
//           display: block;
//           color: #022c32;
//           margin: 5px 0;
//           font-size: 15px;
//           text-decoration: none;
//           transition: .2s;
//         }

//         .footer-col a:hover {
//           color: #03b8b3;
//           transform: translateX(4px);
//         }

//         .social {
//           display: flex;
//           gap: 14px;
//           margin-top: 10px;
//         }

//         .social svg {
//           font-size: 28px;
//           cursor: pointer;
//           transition: .3s;
//           color: #022c32;
//         }

//         .social svg:hover {
//           transform: scale(1.2);
//           color: #03b8b3;
//         }

//         .footer-bottom {
//           text-align: center;
//           margin-top: 20px;
//           font-size: 14px;
//           opacity: .8;
//         }

//         @media(max-width: 768px) {
//           .footer-content {
//             grid-template-columns: 1fr;
//             text-align: center;
//           }
//           .social {
//             justify-content: center;
//           }
//         }
//       `}</style>

//       <footer className="footer">
//         <div className="footer-content">
//           <div className="footer-col">
//             <h4 style={{ cursor: "pointer" }}>
//               <a href="/" style={{ textDecoration: "none", color: "inherit" }}>
//                 RefreshH2O
//               </a>
//             </h4>
//             <p>Your trusted water delivery partner 💧</p>

//             {/* ✅ MUI Icons */}
//             <div className="social">
//               <a
//                 href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FacebookIcon />
//               </a>
//               <a
//                 href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <InstagramIcon />
//               </a>
//               <a
//                 href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <TwitterIcon />
//               </a>
//               <a
//                 href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <YouTubeIcon />
//               </a>
//             </div>
//           </div>

//           <div className="footer-col">
//             <h4>Quick Links</h4>
//             <Link to="/home">Home</Link>
//             <Link to="/bookservices">Book Services</Link>
//             <Link to="/about">About Us</Link>
//             <Link to="/contactus">Contact Us</Link>
//           </div>

//           <div className="footer-col">
//             <h4>Contact</h4>
//             <p>📍 Vijay Nagar Indore, Madhya Pradesh</p>
//             <p>📞 +91 76111 00056</p>
//             <p>✉️ support@refreshh2o.com</p>
//           </div>
//         </div>

//         <div className="footer-bottom">
//           © {new Date().getFullYear()} RefreshH2O | All Rights Reserved 💧
//         </div>
//       </footer>
//     </>
//   );
// }


import React from "react";
import { Link } from "react-router-dom";

// ✅ MUI Icons
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";

export default function Footer() {
  return (
    <>
      <style>{`
        .footer {
          background: rgba(255,255,255,0.85);
          backdrop-filter: blur(10px);
          padding: 40px 20px 15px;
          color: #022c32;
          font-family: "Poppins", sans-serif;
          border-top: 1px solid rgba(0,0,0,0.1);
          {/* margin-top: 100px; */}

        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          max-width: 1100px;
          margin: auto;
        }

        .footer-col h4 {
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 12px;
          color: #03b8b3;
        }

        .footer-col a {
          display: block;
          color: #022c32;
          margin: 5px 0;
          font-size: 15px;
          text-decoration: none;
          transition: .2s;
        }

        .footer-col a:hover {
          color: #03b8b3;
          transform: translateX(4px);
        }

        .social {
          display: flex;
          gap: 14px;
          margin-top: 10px;
        }

        .social svg {
          font-size: 28px;
          cursor: pointer;
          transition: .3s;
          color: #022c32;
        }

        .social svg:hover {
          transform: scale(1.2);
          color: #03b8b3;
        }

        .footer-bottom {
          text-align: center;
          margin-top: 20px;
          font-size: 14px;
          opacity: .8;
        }

        @media(max-width: 768px) {
          .footer-content {
            grid-template-columns: 1fr;
            text-align: center;
          }
          .social {
            justify-content: center;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-col">
            <h4 style={{ cursor: "pointer" }}>
              <a href="/" style={{ textDecoration: "none", color: "inherit" }}>
                RefreshH2O
              </a>
            </h4>
            <p>Your trusted water delivery partner 💧</p>

            {/* ✅ MUI Icons */}
            <div className="social">
              <a
                href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://www.instagram.com/refresh.h2o?igsh=NmQ5aXBwczk1eTV3"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YouTubeIcon />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <Link to="/home">Home</Link>
            <Link to="/bookservices">Book Services</Link>
            <Link to="/about">About Us</Link>
            <Link to="/contactus">Contact Us</Link>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <p>📍 Vijay Nagar Indore, Madhya Pradesh</p>
            <p>📞 +91 99262 02603</p>
            <p>✉️ Refreshh2o.0056@gmail.com</p>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} RefreshH2O | All Rights Reserved 💧
        </div>
      </footer>
    </>
  );
}